import ArrowBack from "@mui/icons-material/ArrowBack";
import { AppBar, Button, IconButton, Toolbar, Typography, useTheme } from "@mui/material";
import { PropsWithChildren, type JSX } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/logo.png";


export enum SettingsActionEnum {
    OK = 1,
    Close = 2
};

export type SettingsBarProps = {
    onClose: (action: SettingsActionEnum) => void;
    title: string | JSX.Element | null;
    modified?: boolean;
    hideAction?: boolean;
    okayLabel?: string;
    showLogo?: boolean;
    hideClose?: boolean;
    actions?: JSX.Element
};

export default function SettingsBar({ 
    title, 
    onClose, 
    modified, 
    hideAction, 
    okayLabel,
    showLogo,
    hideClose,
    actions,
    children
}: PropsWithChildren<SettingsBarProps>) {
    

    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <AppBar 
            sx={{
                position: 'relative',
                '& [disabled]': {
                    color: '#fff',
                    opacity:  0.3
                }
            }}
        >
            <Toolbar>
                {
                    !hideClose &&
                    <IconButton edge="start" color="inherit" onClick={() => onClose(SettingsActionEnum.Close)} aria-label="close">
                        <ArrowBack />
                    </IconButton>
                }

                {
                    showLogo &&
                    <img src={logo} alt="eLynx Technologies" />
                }


                <Typography variant="h6" 
                    sx={{
                        marginLeft: theme.spacing(2),
                        flex: 1,
                    }}
                    >
                    {title}
                </Typography>
                {
                    !hideAction ? 
                    <Button autoFocus 
                        color= {modified ? "secondary" : 'inherit' }
                        arial-label='save' 
                        disabled={!modified} 
                        sx={{
                            color: modified ? undefined : 'rgba(255,255,255,.4)!important',
                            opacity: modified ? undefined : '.6!important'
                        }}
                        onClick={() => onClose(SettingsActionEnum.OK)}>
                        {okayLabel ?? t('buttons.save')}
                    </Button> :
                    actions
                    
                }
            </Toolbar>
            {children}
        </AppBar>
    
    );
};




